<div class='round-history'>
    <p class='page-header'>Playing history</p>
    <p [hidden]='historyRoundList.length !== 0 || isLoading'>Round history empty :(</p>
    <img [hidden]='!isLoading' src="assets/img/spinner.svg">
    <ul [hidden]='historyRoundList.length === 0 || isLoading'>
        <li (click)='navigateRound(item.roundToken)' *ngFor='let item of historyRoundList'>

            <div class='grid-container'>
                <div class='course-name'>{{ item.course }}</div>
                <div class='play-info'>
                    <text-with-icon [title]="item.date | date: 'dd MMM yyyy'" icon='assets/img/calendar.svg'/>
                    <text-with-icon [title]='getScoringInfo(item.scoringSettings, item.format)' icon='assets/img/scorecard.svg'/>
                </div>

                <div class="score-container">
                    <score [scoringSettings]="item.scoringSettings" [totalGrossScore]="item.owner.totalGrossScore" [totalScorePoints]="item.owner.totalScorePoints"/>
                </div>

                <div class='icon-container'>
                    <img alt="arrow-right" height='24' ngSrc='assets/img/arrow-right.svg' width='16'/>
                </div>
            </div>
            <div class='buddies-info'>
                <group-profile-image [images]='getProfileImages(item.buddies)'/>
                <span>{{ getBuddiesString(item.buddies) }}</span>
            </div>
        </li>
    </ul>
</div>